<template>
  <div class="workingSchedule">
    <el-container>
      <el-header>
        <el-form :inline="true" class="demo-form-inline">
          <!-- <el-form-item label="日期">
            <el-date-picker
              v-model="QueryMonth"
              value-format="yyyy-MM"
              type="month"
              placeholder="选择月"
            >
            </el-date-picker>
          </el-form-item> -->
          <!-- <el-form-item>
            <el-button type="primary">查询</el-button>
          </el-form-item> -->
        </el-form>
      </el-header>

      <el-main>
        <template>
          <table class="head" style="width:100%">
            <tr>
              <th rowspan="2" style="width:10%"> {{ $t('original.languages283') }}</th>
              <th rowspan="2" style="width:10%"> {{ $t('original.languages284') }}</th>
              <th :colspan="ConAddressName.length">
                {{ year }}年第{{ week }}周心理咨询排班
              </th>
            </tr>
            <tr>
              <th v-for="(item, itemIndex) in ConAddressName" :key="itemIndex"
                :style="'width:' + 80 / ConAddressName.length + '%;  '">
                {{ item }}
              </th>
            </tr>
          </table>

          <div v-for="(item, itemIndex) in WeekList" :key="itemIndex">
            <table style="width:100%">
              <tr :style="
                itemIndex % 2 == 1 ? ' background-color: #bfbfbf; ' : ''
              ">
                <td rowspan="3" style="width:10%" :class="'week' + itemIndex">
                  {{ item }}（{{
                      new Date(
                        new Date(starTime).setDate(
                          new Date(starTime).getDate() + itemIndex
                        )
                      ).getDate()
                  }}号）
                </td>
                <td style="width:10%"> {{ $t('original.languages286') }}</td>
                
                <td :style="'width:' + 80 / ConAddressName.length + '%;  '"
                  v-for="(ConAddressKey, ConAddressKeyindex) in ConAddressName" :key="ConAddressKeyindex">

                  <div v-for="(key, keyIndex) in counselorList" :key="keyIndex">
                    <div style="padding:5px" v-if="key.ConAddressName == ConAddressKey &&  key.TimeFrame == '上午' && getdateTime(key.SchedulDate, itemIndex)
                    ">
                      {{ key.RealName }}({{ key.RoleName }})
                      {{ key.StartTime }}-{{ key.FinishTime }}
                    </div>
                  </div>
                </td>
              </tr>

              <tr :style="itemIndex % 2 == 1 ? ' background-color: #bfbfbf; ' : ''">
                <td>{{ $t('original.languages287') }}</td>
                <td v-for="(ConAddressKey, ConAddressKeyindex) in ConAddressName" :key="ConAddressKeyindex">
                  <div v-for="(key, keyIndex) in counselorList" :key="keyIndex">
                    <div v-if="
                      getdateTime(key.SchedulDate, keyIndex) &&
                      key.ConAddressName == ConAddressKey &&
                      key.TimeFrame == '下午'
                    ">
                      {{ key.RealName }} {{ key.StartTime }} -
                      {{ key.FinishTime }}
                    </div>
                  </div>
                </td>
              </tr>
              <tr :style="
                itemIndex % 2 == 1 ? 'background-color: #bfbfbf; ' : ''
              ">
                <td>{{ $t('original.languages285') }}</td>
                <td v-for="(ConAddressKey, ConAddressKeyindex) in ConAddressName" :key="ConAddressKeyindex">
                  <div v-for="(key, keyIndex) in counselorList" :key="keyIndex">
                    <div v-if="
                      getdateTime(key.SchedulDate, keyIndex) &&
                      key.ConAddressName == ConAddressKey &&
                      key.TimeFrame == '晚上'
                    ">
                      {{ key.RealName }} {{ key.StartTime }} - {{ key.FinishTime }}
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </template>
      </el-main>
    </el-container>
  </div>
</template>
<script>
export default {
  mounted() {
    this.GetcounselorList();
  },
  data() {
    return {
      QueryMonth: '',
      starTime: '',
      counselorList: [],
      ConAddressName: [],
      week: 0,
      year: 0,
      WeekList: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
    };
  },
  methods: {
    getdateTime(star, end) {
      let times =
        new Date(this.starTime).getFullYear() +
        '-' +
        (new Date(this.starTime).getMonth() + 1 > 9
          ? new Date(this.starTime).getMonth() + 1
          : '0' + (new Date(this.starTime).getMonth() + 1)) +
        '-' +
        (new Date(this.starTime).getDate() + end);
      return star == times;
    },
    GetcounselorList() {
      this.$Http_Post('ConsultSubscribe/ShowWeekScheduling', {}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          let data = res.Data;
          this.counselorList = data.List;
          this.starTime = data.StarDateTime;
          this.ConAddressName = data.ConAddressName;
          this.week = data.Week;
          this.year = data.Year;
        } else {
        }
      });
    },
  },
};
</script>
<style>
table {
  border-spacing: 0px !important;
}

table tr th {
  border-top: 1px solid rgb(168, 168, 168);
  border-left: 1px solid rgb(168, 168, 168);
}

table tr td {
  border-top: 1px solid #ddd;
  border-left: 1px solid #ddd;
  height: 20px;
}

.workingSchedule .head {
  height: 80px;
}

.workingSchedule .head th {
  background: rgb(207, 207, 207);
}

.week0 {
  background-color: rgb(202, 202, 118);
}

.week1 {
  background-color: rgb(224, 126, 91);
}

.week2 {
  background-color: rgb(79, 180, 79);
}

.week3 {
  background-color: rgb(13, 202, 202);
}

.week4 {
  background-color: brown;
}

.week5 {
  background-color: blueviolet;
}

.week6 {}
</style>
